import { render, staticRenderFns } from "./DashboardKpiCard.vue?vue&type=template&id=d3abb744&scoped=true"
import script from "./DashboardKpiCard.vue?vue&type=script&lang=js"
export * from "./DashboardKpiCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardKpiCard.vue?vue&type=style&index=0&id=d3abb744&prod&lang=scss&scoped=true"
import style1 from "./DashboardKpiCard.vue?vue&type=style&index=1&id=d3abb744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3abb744",
  null
  
)

export default component.exports